import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from '@/router'
import { i18n } from '@/i18n'
import { localizedRoute } from '@/composables/useLocalizedRoute'
import '@/assets/styles/imports.styl'

const app = createApp(App)

app.config.globalProperties.$i18nRoute = localizedRoute
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')
